import { ContentContainer, LoadingSpinner, Header } from '../components/Generic'
import styled from 'styled-components'
import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { StoreContext } from '../components/App'
import { devLog } from '../methods/devLog'
import { axiosInstance } from '../methods/axiosConfig'
import { forceRedirect } from '../methods/forceRedirect'
import { useInterval } from 'usehooks-ts'
import { usePageVisibility } from '../hooks/usePageVisibility'

interface PollingResponse {
  status: string
  shouldWait: boolean
  location?: string
}

const WarningLine = styled.h3<{ fontFamily: string }>`
  color: #e04d39;
  width: 100%;
  text-align: center;
  font-family: inherit;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  margin: 0px;
  font-family: ${({ fontFamily }) => fontFamily};
`

export const WaitingAfterGoToMobilePage = observer(() => {
  const store = useContext(StoreContext)
  const { theme } = store.InterfaceState
  const { SwitchToMobile: trans } = store.TranslationsState.translations
  const apiUrl = process.env.WEB_API_URL

  const [shouldWait, setShouldWait] = useState(true)
  const [shouldPoll, setShouldPoll] = useState(true)

  const isVisible = usePageVisibility()

  const checkStatus = async (): Promise<PollingResponse> => {
    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${apiUrl}/${process.env.ONBOARDING_WEB_API_PATH}/waiting-till-end`,
        { withCredentials: true }
      )

      if (!res.data.shouldWait) {
        setShouldWait(false)

        const location = res.data.location && res.data.location

        forceRedirect(location)
      }

      return res.data
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    setShouldPoll(isVisible)
  }, [isVisible])

  useEffect(() => {
    shouldWait && shouldPoll && checkStatus()
  }, [shouldWait, shouldPoll])

  useInterval(checkStatus, shouldWait && shouldPoll ? 3000 : null)

  return (
    <ContentContainer
      {...theme.container}
      width="560px"
      paddingMobile="20px"
      marginMobile="0"
    >
      <Header
        {...theme.header}
        fontFamily={theme.globals.fontFamilyHeadline}
        margin="30px 0"
      >
        {trans.waitingForMobile.header}
      </Header>

      <WarningLine fontFamily={theme.globals.fontFamily}>
        {trans.waitingForMobile.description}
      </WarningLine>

      <LoadingSpinner
        width="68px"
        padding="100px 0"
        {...theme.loadingSpinner}
      />
    </ContentContainer>
  )
})
